"use strict";
const angular = require("angular");

/*@ngInject*/
export function projectService($resource) {
  // AngularJS will instantiate a singleton by calling "new" on this function
  "ngInject";

  return $resource(
    "/api/projects/:id/:controller",
    {
      id: "@id",
    },
    {
      get: { method: "GET" },
      save: { method: "POST" },
      change: { method: "PUT" },
      query: { method: "GET", isArray: true },
      delete: { method: "DELETE" },
      manageUser: { method: "PUT", params: { controller: "manage-user" } },
    }
  );
}

export default angular
  .module("dalApp.project.api", [])
  .service("ProjectAPI", projectService).name;



// WEBPACK FOOTER //
// ./client/app/permission/project/project.service.js